export class APIResultState {
    public static readonly loading: string = "loading";
    public static readonly loaded: string = "loaded";
    public static readonly error:string = "error";
}